// src/api/sequenceApi.js
// The server-side atomic counter for proposal (P) and quote (Q) numbers.
//
// ⚠ These numbers cannot be worked out in the browser. Proposals live in the
// per-user state blob, which is overwritten WHOLE with no precondition, so a
// number derived from the records themselves can be taken twice by two
// proposals created in quick succession — and nothing would show it until two
// documents carried the same P number in front of a customer. The backend
// increments a dedicated blob under a compare-and-swap; this is the client.
import api from "./apiClient";

/** Reserve the next number. ⚠ CONSUMES it — there is no release. */
export async function reserveNumber(name) {
  const { data } = await api.post("/api/sequence/next", { name });
  return data;                        // { number, formatted }
}

/** What would be issued next, WITHOUT consuming it. Display only — never
 *  assign from this, or the race the counter closes is reopened here. */
export async function peekNext(name) {
  const { data } = await api.get(`/api/sequence/peek?name=${encodeURIComponent(name)}`);
  return data.next;
}

/** Carry the counter past numbers the backfill assigned by hand. Never moves
 *  backwards — a lower value would re-issue numbers already in use. */
export async function ensureAtLeast(name, value) {
  const { data } = await api.post("/api/sequence/ensure-at-least", { name, value });
  return data.next;
}
